import { Stack, Typography } from '@mui/material';
import type { MeterInput, NewMeter } from '@weft/types';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { CreateProductPageConditions } from './CreateProductPageConditions/CreateProductPageConditions';
import { CreateProductPageSummary } from './CreateProductPageSummary';
import { EventNameSelect } from './EventNameSelect';
import { SectionContainer } from './SectionContainer';
import { SectionContainerItem } from './SectionContainerItem';

export const CreateProductPageForm: React.FC = () => {
  const { control } = useFormContext<MeterInput, unknown, NewMeter>();

  return (
    <Stack
      rowGap={3}
      sx={{
        position: 'relative',
        '::before': {
          content: '""',
          position: 'absolute',
          left: 'calc(50% - 0.5px)',
          display: 'block',
          width: '1px',
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
          height: '100%',
          zIndex: 0,
        },
        '> *': {
          position: 'relative',
          zIndex: 1,
        },
      }}
    >
      <SectionContainer
        title="Events"
      >
        <SectionContainerItem>
          <Typography variant="subtitle1">When this event name is</Typography>

          <Controller
            control={control}
            name="eventName"
            render={({ field }) => (
              <EventNameSelect
                value={field.value}
                onChange={(event, newValue) => {
                  event.preventDefault();
                  field.onChange(newValue);
                }}
              />
            )}
          />
        </SectionContainerItem>
      </SectionContainer>

      <CreateProductPageConditions/>

      <CreateProductPageSummary/>
    </Stack>
  );
};